export function modifyURL(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    var kvp = document.location.search.substr(1).split('&');
    let i=0;

    for(; i<kvp.length; i++){
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=');
            pair[1] = value;
            kvp[i] = pair.join('=');
            break;
        }
    }

    if(i >= kvp.length)
        kvp[kvp.length] = [key,value].join('=');

    let params = kvp.join('&');
    window.history.pushState({}, null, window.location.href.split('?')[0] + "?" + params);
}

export function removeParamURL(key) {
    let keys = Array.isArray(key) ? key : [key]
    let sourceURL = document.location.search
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (keys.includes(param)) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    window.history.pushState({}, null, rtn);
    return rtn;
}

export function getParamURL(key) {
    const query = new URLSearchParams(window.location.search);
    return query.get(key);
}

export function num_word(value, words){  
    value = Math.abs(value) % 100; 
    var num = value % 10;
    if(value > 10 && value < 20) return words[2]; 
    if(num > 1 && num < 5) return words[1];
    if(num === 1) return words[0]; 
    return words[2];
}